module.exports = __webpack_public_path__ + "static/breakout-bc387155bc51777490d7b00f77fc009d.jpg";